import React, { useState, useEffect } from "react";
import axiosInstance from "../ReusableComponents/Axios";
import InternetChecking from "../Student/Reusablecomponents/Network";
import Loading from "../Student/Reusablecomponents/Loading";
import DataTable from "../Student/Reusablecomponents/DataTable/DataTable";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { format } from "date-fns";
const ASDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const [AssessmenTesTypes, SetAssessmenTesTypes] = useState([]);

  const [TestDetails, SeTestDetails] = useState();
  const [Load, SetLoad] = useState(false);

  const GetTestDetails = async () => {
     SeTestDetails();
      if (USYear?.display === "2024-25" || USYear?.display === "2025-26") {
      SetAssessmenTesTypes([
        { title: "SODHANA", type: 1 }, 
        { title: "SADHANA", type: 2 },
        { title: "SAMAGRA", type: 3 }
      ]);
    } else {
      SetAssessmenTesTypes([
        { title: "SODHANA", type: 1 },
        { title: "SAMAGRA", type: 3 }
      ]);
    }
    SetLoad((prev) => !prev);
    try {
      const response = await axiosInstance.get(
        `/Assessment/GetStudentQuestionAnswerSheet?UserId=${items?.userId}&Year=${USYear?.value}`
      );
      SeTestDetails(response.data);
      SetLoad((prev) => !prev);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (USYear?.value) {
      GetTestDetails();
    }
  }, [USYear]);

  const QPNavigation = (Row) => {
    // if(Row.viewQuestionPaper){
    navigate("/ViewAnswerSheetDetails/Question Paper", {
      state: {
        CCID: Row?.contestCreationID,
        Grade: items?.grade,
        AType: Row?.assessmentType,
        date: Dateformat(Row?.examAvailabilityEndDate.split(" ")[0]),
        instituteId: items?.instituteId,
        paperSets: Row?.paperSets,
        QHindi:Row?.isAssessmentinHindi,
           ATName: Row?.assessmentTypeNo,
          Duration: Row?.duration,
           Subjects: Row?.subjects,
      },
    });
    // }
  };
  const Dateformat = (e) => {
    const [day, month, year] = e.split("-");
    // console.log("ddd", day, month, year)
    const date = new Date(`${year}-${month}-${day}`);
    return format(date, "dd MMM yyyy");
  }
  const ReportCardNavigation = (Row) => {
    navigate("/Principle/PrincipleReportCard", {
      state: {
        CCID: Row?.contestCreationID,
        AType: Row?.assessmentType,
        Date: Row?.examAvailabilityEndDate,
      },
    });
  };
  // const AssessmenTesTypes = [
  //   { title: "SODHANA", type: 1 },
  //   { title: "SADHANA", type: 2 },
  //   { title: "SAMAGRA", type: 3 },
  // ];
  const renderRows = (type) => {
    const filtered = TestDetails?.filter((item) => item.assessmentType === type);
    if (!filtered?.length) {
      return (
        <tr> <td colSpan={5} > ** No data available ** </td> </tr>
      );
    }

    return filtered?.map((item) => (
      <tr key={item.assessmentTypeNo}>
        <td>{item?.assessmentTypeNo.split(" ")[1]}</td>
        <td>{Dateformat(item.examAvailabilityStartDate.split(" ")[0])}</td>
        <td className="LinkStyles" onClick={() => QPNavigation(item)}>
          View & Download
        </td>
      </tr>
    ));
  };
  return (
    <>
      <div className=" TeacherBgImage">
        <InternetChecking />

        <h5 className="MainHeading"> Assessment Details </h5>
        <div className="NCLDataTable mt-2">
          <table className="Data-Table" style={{ tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th>Assessment No</th>
                <th>Assessment Date</th>
                <th>Question Paper</th>
              </tr>
            </thead>

          </table>
        </div>

        {TestDetails && AssessmenTesTypes.map(({ title, type }) => (
          <div className="Card NCLDataTable mt-2">
            <div className="SubHeading mt-1 mb-2">{title}</div>
            <table className="Data-Table" style={{ tableLayout: "fixed" }}>
              <tbody>
                {renderRows(type)}
              </tbody>
            </table>
          </div>
        ))}

        {Load && <Loading />}
      </div>
    </>
  );
};
export default ASDetails;
